export default __webpack_public_path__ + "static/PromptIconSix-38ec7693aa1939bbcb994f654fe24902.png";